import { Table } from "antd";
import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import {  useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import EmployeeLeaveModelPopup from "../../../../components/modelpopup/EmployeeLeaveModelPopup";
import SearchBox from "../../../../components/SearchBox";
import { base_url } from "../../../../base_urls";
import { getLeaveSummary , getLeaveList, LeavePlannerCalender} from "api/services/leave";
import {itemRender, handlePageChange, defaultPagination, pageSizeOptions} from "utils/table";
import { useSearchParams } from 'react-router-dom';
import {  useNavigate } from "react-router-dom";
import Image from "components/Image";
import { formatDateHandler2 } from "utils/common";
import { getLeaveType } from 'api/services/common';
import EmployeeLeaveFilter from "../components/employeeLeaveFilter"
import useEmployeeLeaveFilter from "../hooks/filterLeaveHook"
import  FilterDrawer from "components/Drawer/leaveFilterDrawer"
import { filterHandler } from 'utils/common';
import dayjs from "dayjs"; // AntD uses dayjs for date handling

import { Badge, Calendar } from 'antd';
// import dayjs from "dayjs";
// import "antd/dist/reset.css"; // Import AntD styles
import { format } from "date-fns";

import LeavePlannerModal from "components/modelpopup/createLeavePlan"
import FilterSelect from "components/Form/filterSelect";
const EmployeeLeave = () => {
  const currentYear = dayjs().year();
  const nextYear = currentYear + 1;
 

  const [leaveSummary, setLeaveSummary] = useState({})
  const [users, setUsers] = useState([]);
  const [leaves, setLeaves] = useState([]);
  const [leavesLoading, setLeavesLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [leaveModal, setLeaveModal] = useState(false);

  const [leaveTypes, setLeaveTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFilterDrawer, setShowFilterDrawer] = useState(false)


  const [selectedLeave, setSelectedLeave] = useState("");
  const [appliedFilterCount, setAppliedFilterCount] = useState(0);
  const [calendarData, setCalendarData] = useState([]);
  const [currentDate, setCurrentDate] = useState(dayjs());
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [userOptions, setUserOptions] = useState([]);

  const [leavePlannerModal, setLeavePlannerModal] = useState(false);
  const [selectedLeavePlanner, setSelectedLeavePlanner] = useState("");
  const {
    user, userLoading   ,

} = useSelector((state) => state.user);

const {
  userData, userDataLoading,

} = useSelector((state) => state.common);


useEffect(()=>{
  let current = [...userOptions].filter(item=>item.value === user?.id)
  setSelectedUsers(current)
},[userOptions])
  const getFilterParams = useCallback(()=>{
    let filter_params = filterHandler(filters)

      return filter_params
          
  })



  const navigate = useNavigate();

  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_byb") || "",

})

const { handleFilterChange,
  filters,
  handleInputChange, filterLoading, setFilterLoading, handleDateChange} = useEmployeeLeaveFilter(pageSettings , setPageSettings);



  const fetchLeavePlanner = () => {
    setLoading(true)
    const  month = currentDate.month()
    const year = currentDate.year() 
    const company_users = selectedUsers.map(item=> item.value)
    // company_users.push(user?.id)
    LeavePlannerCalender({
      company_user: company_users.join(","),
      // company_user:1,
      month: month+1, 
      year
    }).then(response => {
      setCalendarData(response.data.results)
      setLoading(false)
      console.log(response.data, "DATAAA")
    }).catch(e=>{
      setLoading(false)
    })
  }
  useEffect(()=>{
    fetchLeavePlanner()
  },[currentDate, selectedUsers])

  useEffect(()=>{
    console.log(userData, "UUUUU")
    let _userData = userData?.map(item=> {
      return{
          label: item.first_name+" "+item.last_name,
          value: item.id
      }
  })
  setUserOptions(_userData)

  },[userData])

  const getListData = (value, type) => {
    console.log("Formatted Date:", );
    if(type == "day"){
      let date = value.format("YYYY-MM-DD")
      console.log(date, "DATEEEEEEEE")
      let filtered_data = [...calendarData].filter(item=> item.date === date)
      console.log(filtered_data, "FILTERESSSSS")
  
      return filtered_data
    }else{
      let date = value.month() + 1
      console.log(date,calendarData, "DATEEEEEEEE")
      let filtered_data = [...calendarData].filter(item=> format(new Date(item.date), "L") == date)
      console.log(filtered_data, "FILTERESSSSS")
  
      return filtered_data
    }

  };

  const getMonthData = (value) => {
    if (value.month() === 8) {
      return 1394;
    }
  };
  const monthCellRender = (value) => {
    // const num = getMonthData(value);
    console.log(value, "KKKKK")
    const listData = getListData(value, "month");
    console.log(listData, "KKKKKKKKKKKK")
    return listData ? (
      <ul onClick={(e) => e.stopPropagation()} className="events">
      {listData.map((item) => (
        <li  className="badge-container-calendar" key={item.content}>
          <Badge 
          className="calendar-custom-span"
          // style={{fontSize:"8px !important"}}
          fontSize={9}
          style={{ fontSize: "9px" }} 
          // count={
          //    <i className="fa fa-edit" />
          // } 
          onClick={e=>{
            setSelectedLeavePlanner(item)
            setLeavePlannerModal(true)
            // console.log(e, "LLLL")
            // e.stop
            // e.stopP
          }}  
          status={"success"} 
          text={`${item?.leave_planner?.company_user?.first_name} ${item?.leave_planner?.company_user?.last_name} | ${item.leave_planner?.leave_type?.description}`} />
          
        </li>
      ))}
    </ul>
    ) : null;
  };
  const dateCellRender = (value) => {
    const listData = getListData(value, "day");
    return (
      <ul onClick={(e) => e.stopPropagation()} className="events">
        {listData.map((item) => (
          <li  className="badge-container-calendar" key={item.content}>
            <Badge 
            className="calendar-custom-span"
            // style={{fontSize:"8px !important"}}
            fontSize={9}
            style={{ fontSize: "9px" }} 
            // count={
            //    <i className="fa fa-edit" />
            // } 
            onClick={e=>{
              setSelectedLeavePlanner(item)
              setLeavePlannerModal(true)
              // console.log(e, "LLLL")
              // e.stop
              // e.stopP
            }}  
            status={"success"} 
            text={`${item?.leave_planner?.company_user?.first_name} ${item?.leave_planner?.company_user?.last_name} | ${item.leave_planner?.leave_type?.description}`} />
            
          </li>
        ))}
      </ul>
    );
  };

  const cellRender = (current, info) => {
    console.log(current, "KKKK")
    if (info.type === 'date') return dateCellRender(current);
    if (info.type === 'month') return monthCellRender(current);
    return info.originNode;
  };

    // Handle year and month change
    // const onPanelChange = (value, mode) => {

    // };
    const onDateSelect = (date, mode) => {
      if(mode?.source == "date"){
        // console.log(mode, "LLL")
        // setSelectedDate(date);
        // setLeavePlannerModal(true)
        // // setSelectedDate(date)
        // console.log("Clicked Date:", date.format("DD-MM-YYYY")); // Logs selected date
      }else{
        setCurrentDate(date)
        // setCurrentDate( value.month(), value.year()); // Convert moment object to Date
        console.log( date.month(), date.year());
      }

    };
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Leave Planner"
            title="Dashboard"
            subtitle="Leaves"
            modal="#add_leave_plan"
            name="Add Leave Plan"
            setLeavePlannerModal={setLeavePlannerModal}
            hideGrid={true}
          />


      <div className="col-md-4" >
      <FilterSelect isMulti isClearable={true}  onChange={e=>setSelectedUsers(e)} optionLabel={"label"} optionValue={'value'}  options={userOptions} isLoading={userDataLoading}  value={selectedUsers} placeholder={"Filter by user"}/>
      </div>
      <Calendar  
      validRange={[dayjs(`${currentYear}-01-01`), dayjs(`${nextYear}-12-31`)]} 
      onSelect={onDateSelect}
       value={currentDate}
      //  onPanelChange={onPanelChange}
        cellRender={cellRender} 
        // disabledDate={disabledDate}  
        />


    <LeavePlannerModal 
    user={user}
    leavePlannerModal={leavePlannerModal}
    setLeavePlannerModal={setLeavePlannerModal}
    selectedLeavePlanner={selectedLeavePlanner}
    fetchLeavePlanner={fetchLeavePlanner}
    setSelectedLeavePlanner={setSelectedLeavePlanner}
     />
       </div>
       </div>
    </>
  );
};

export default EmployeeLeave;
